import fetchClient from '../Services/fetchClient';
import { clearClientSiteForEdit } from '../State/clientSiteForEdit';

export default () => async (dispatch) => {

  dispatch(fetchClient());
  dispatch(clearClientSiteForEdit());
}
